import styled from "styled-components";

const StrongLabel = styled.span`
  font-weight: bold;
  color: black;
`;

export default StrongLabel;
